import React from 'react';

const GlassCard = ({ 
  children, 
  className = '', 
  hover = false,
  variant = 'default', // 'default', 'strong', 'subtle'
  ...props 
}) => {
  const variants = {
    default: 'glass',
    strong: 'glass-strong',
    subtle: 'glass-subtle',
  };

  const hoverClass = hover ? 'card-hover-glow cursor-pointer' : '';

  return (
    <div
      className={`
        ${variants[variant]}
        ${hoverClass}
        rounded-2xl
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default GlassCard;
